<template>
  <div id="details-app-page" class="main-page">
    <div class="container" v-if="complete">
      <p class="app-page-title">Summary</p>

      <div class="app-section">
        <p class="app-section-title">User</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">User Information</td>
            </tr>
            <tr>
              <td>Full name</td>
              <td>{{detail.fullname}}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{detail.app_user}}</td>
            </tr>
            <tr>
              <td>Application type</td>
              <td>{{detail.app_name}}</td>
            </tr>
            <tr>
              <td>Application ID</td>
              <td>{{detail.uid}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Business</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Name of Primary Contact Information</td>
            </tr>
            <tr>
              <td>Name of Primary Contact</td>
              <td>{{ detail.contact.contact || '-'}}</td>
            </tr>
            <tr>
              <td>Primary Contact's Number</td>
              <td>{{detail.contact.contact_number || '-'}}</td>
            </tr>
            <tr>
              <td>Title of Primary Contact</td>
              <td>{{detail.contact.title || '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">General Business Information</td>
            </tr>
            <tr>
              <td>Company Name</td>
              <td>{{detail.company.company_name || '-'}}</td>
            </tr>
            <tr>
              <td>Merchant's Legal Business Name</td>
              <td>{{detail.company.legal_business_name || '-'}}</td>
            </tr>
            <tr>
              <td>Customer Service Phone</td>
              <td>{{detail.company.customer_service_phone || '-'}}</td>
            </tr>
            <tr>
              <td>DBA Name</td>
              <td>{{detail.company.dba_name || '-'}}</td>
            </tr>
            <tr>
              <td>Website URL</td>
              <td>{{detail.company.website_url || '-'}}</td>
            </tr>
            <tr>
              <td>Type of Goods or Services you offer</td>
              <td>{{detail.company.type_offer || '-'}}</td>
            </tr>
            <tr>
              <td>Where do you operate your business?</td>
              <td>{{detail.company.business_operation_name || '-'}}</td>
            </tr>
            <tr>
              <td>Tax ID / EIN</td>
              <td>{{detail.company.tax_id || '-'}}</td>
            </tr>
            <tr>
              <td>How is your Business Zoned</td>
              <td>{{detail.company.business_zone_name || '-'}}</td>
            </tr>
            <tr>
              <td>Number of Locations</td>
              <td>{{detail.company.number_of_locations || '-'}}</td>
            </tr>
            <tr>
              <td>Select Business Type</td>
              <td>{{detail.company.business_type_name || '-'}}</td>
            </tr>
            <tr>
              <td>Start Date of Business</td>
              <td>{{detail.company.business_start_date || '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Business Address</td>
            </tr>
            <tr>
              <td>Street Address</td>
              <td>{{detail.company.business_street_address || '-'}}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{{detail.company.business_state_name || '-'}}</td>
            </tr>
            <tr>
              <td>Zip / Postal Code</td>
              <td>{{detail.company.business_zip_portal || '-'}}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{detail.company.business_city || '-'}}</td>
            </tr>
            <tr>
              <td>Length at Location</td>
              <td>{{detail.company.lenght_location_year || '-'}} years and {{detail.company.lenght_location_month || '-'}} months</td>
            </tr>
            <tr>
              <td>Mail statements to the address above?</td>
              <td>{{ detail.company.same_mailing_address ? 'Yes' : 'No' }}</td>
            </tr>
            <tr v-if="!detail.company.same_mailing_address">
              <td>Mailing Address</td>
              <td>{{detail.mailing_address.mail_address || '-'}}</td>
            </tr>
            <tr v-if="!detail.company.same_mailing_address">
              <td>City</td>
              <td>{{detail.mailing_address.city || '-'}}</td>
            </tr>
            <tr v-if="!detail.company.same_mailing_address">
              <td>State</td>
              <td>{{detail.mailing_address.state_name || '-'}}</td>
            </tr>
            <tr v-if="!detail.company.same_mailing_address">
              <td>Zip / Postal Code</td>
              <td>{{detail.mailing_address.business_zip_portal || '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Ownership</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Ownership Information</td>
            </tr>
            <tr>
              <td>Owner Name</td>
              <td>{{detail.owner.owner_name || '-'}}</td>
            </tr>
            <tr>
              <td>Street Address</td>
              <td>{{detail.owner.street_address || '-'}}</td>
            </tr>
            <tr>
              <td>Transaction Types</td>
              <td v-if="detail.transaction.transaction_type_name.length > 0">
                <p
                  class="business-type"
                  v-for="(val, key) in detail.transaction.transaction_type_name"
                  v-bind:key="val"
                >
                  <span v-if="key !== 0">,</span>
                  {{val}}
                </p>
              </td>
              <td v-else>-</td>
            </tr>
            <tr>
              <td>SSN</td>
              <td>{{detail.owner.ssn || '-'}}</td>
            </tr>
            <tr>
              <td>Rent or Own?</td>
              <td>{{detail.owner.business_status || '-'}}</td>
            </tr>
            <tr>
              <td>Phone</td>
              <td>{{detail.owner.phone_number || '-'}}</td>
            </tr>
            <tr>
              <td>Drivers License or ID State</td>
              <td>{{detail.owner.license_state_name || '-'}}</td>
            </tr>
            <tr>
              <td>Title</td>
              <td>{{detail.owner.title || '-'}}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{detail.owner.city || '-'}}</td>
            </tr>
            <tr>
              <td>Zip / Postal Code</td>
              <td>{{detail.owner.postal_code || '-'}}</td>
            </tr>
            <tr>
              <td>Date of Birth</td>
              <td>{{detail.owner.date_of_birth || '-'}}</td>
            </tr>
            <tr>
              <td>Equity Ownership</td>
              <td>{{detail.owner.ownership ? detail.owner.ownership + '%' : '-'}}</td>
            </tr>
            <tr>
              <td>How long at location</td>
              <td>{{detail.owner.long_at_location_year || '-'}} years and {{detail.owner.long_at_location_month || '-'}} months</td>
            </tr>
            <tr>
              <td>Drivers License or ID#</td>
              <td>{{detail.owner.driver_license_id || '-'}}</td>
            </tr>
            <tr>
              <td>Drivers License or ID expiry Date</td>
              <td>{{detail.owner.license_expiry || '-'}}</td>
            </tr>
          </tbody>
          <tbody v-if="detail.owner.owners&&detail.owner.owners.owner_2">
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Ownership 2 Information</td>
            </tr>
            <tr>
              <td>Owner Name</td>
              <td>{{detail.owner.owners.owner_2.owner_name || '-'}}</td>
            </tr>
            <tr>
              <td>Street Address</td>
              <td>{{detail.owner.owners.owner_2.street_address || '-'}}</td>
            </tr>
            <tr>
              <td>SSN</td>
              <td>{{detail.owner.owners.owner_2.ssn || '-'}}</td>
            </tr>
            <tr>
              <td>Rent or Own?</td>
              <td>{{detail.owner.owners.owner_2.business_status || '-'}}</td>
            </tr>
            <tr>
              <td>Phone</td>
              <td>{{detail.owner.owners.owner_2.phone_number || '-'}}</td>
            </tr>
            <tr>
              <td>Drivers License or ID State</td>
              <td>{{detail.owner.owners.owner_2.license_state_name || '-'}}</td>
            </tr>
            <tr>
              <td>Title</td>
              <td>{{detail.owner.owners.owner_2.title || '-'}}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{detail.owner.owners.owner_2.city || '-'}}</td>
            </tr>
            <tr>
              <td>Zip / Postal Code</td>
              <td>{{detail.owner.owners.owner_2.postal_code || '-'}}</td>
            </tr>
            <tr>
              <td>Date of Birth</td>
              <td>{{detail.owner.owners.owner_2.date_of_birth || '-'}}</td>
            </tr>
            <tr>
              <td>Equity Ownership</td>
              <td>{{detail.owner.owners.owner_2.ownership ? detail.owner.owners.owner_2.ownership + '%' : '-'}}</td>
            </tr>
            <tr>
              <td>How long at location</td>
              <td>{{detail.owner.owners.owner_2.long_at_location_year || '-'}} years and {{detail.owner.owners.owner_2.long_at_location_month || '-'}} months</td>
            </tr>
            <tr>
              <td>Drivers License or ID#</td>
              <td>{{detail.owner.owners.owner_2.driver_license_id || '-'}}</td>
            </tr>
            <tr>
              <td>Drivers License or ID expiry Date</td>
              <td>{{detail.owner.owners.owner_2.license_expiry || '-'}}</td>
            </tr>
          </tbody>
          <tbody v-if="detail.owner.owners&&detail.owner.owners.owner_3">
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Ownership 3 Information</td>
            </tr>
            <tr>
              <td>Owner Name</td>
              <td>{{detail.owner.owners.owner_3.owner_name || '-'}}</td>
            </tr>
            <tr>
              <td>Street Address</td>
              <td>{{detail.owner.owners.owner_3.street_address || '-'}}</td>
            </tr>
            <tr>
              <td>SSN</td>
              <td>{{detail.owner.owners.owner_3.ssn || '-'}}</td>
            </tr>
            <tr>
              <td>Rent or Own?</td>
              <td>{{detail.owner.owners.owner_3.business_status || '-'}}</td>
            </tr>
            <tr>
              <td>Phone</td>
              <td>{{detail.owner.owners.owner_3.phone_number || '-'}}</td>
            </tr>
            <tr>
              <td>Drivers License or ID State</td>
              <td>{{detail.owner.owners.owner_3.license_state_name || '-'}}</td>
            </tr>
            <tr>
              <td>Title</td>
              <td>{{detail.owner.owners.owner_3.title || '-'}}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{detail.owner.owners.owner_3.city || '-'}}</td>
            </tr>
            <tr>
              <td>Zip / Postal Code</td>
              <td>{{detail.owner.owners.owner_3.postal_code || '-'}}</td>
            </tr>
            <tr>
              <td>Date of Birth</td>
              <td>{{detail.owner.owners.owner_3.date_of_birth || '-'}}</td>
            </tr>
            <tr>
              <td>Equity Ownership</td>
              <td>{{detail.owner.owners.owner_3.ownership ? detail.owner.owners.owner_3.ownership + '%' : '-'}}</td>
            </tr>
            <tr>
              <td>How long at location</td>
              <td>{{detail.owner.owners.owner_3.long_at_location_year || '-'}} years and {{detail.owner.owners.owner_3.long_at_location_month || '-'}} months</td>
            </tr>
            <tr>
              <td>Drivers License or ID#</td>
              <td>{{detail.owner.owners.owner_3.driver_license_id || '-'}}</td>
            </tr>
            <tr>
              <td>Drivers License or ID expiry Date</td>
              <td>{{detail.owner.owners.owner_3.license_expiry || '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Transactions</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Current Sales Volume</td>
            </tr>
            <tr>
              <td>What's your estimated average sales per month?</td>
              <td>{{detail.transaction.sales_average ? '$'+ detail.transaction.sales_average : '-'}}</td>
            </tr>
            <tr>
              <td>What's your average transaction Amount?</td>
              <td>{{detail.transaction.transaction_average ? '$'+ detail.transaction.transaction_average : '-'}}</td>
            </tr>
            <tr>
              <td>What's your maximum transaction Amount?</td>
              <td>{{detail.transaction.max_transaction ? '$'+ detail.transaction.max_transaction : '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td
                class="details-section"
                colspan="2"
              >Tell us how you are going to accept your payments</td>
            </tr>
            <tr>
              <td>On Premise Sales</td>
              <td>{{detail.transaction.on_premise_sales ? detail.transaction.on_premise_sales + '%' : '-'}}</td>
            </tr>
            <tr>
              <td>Mail Order</td>
              <td>{{detail.transaction.mail_order ? detail.transaction.mail_order + '%' : '-'}}</td>
            </tr>
            <tr>
              <td>Off Premise Sales</td>
              <td>{{detail.transaction.off_premise_sales ? detail.transaction.off_premise_sales + '%' : '-'}}</td>
            </tr>
            <tr>
              <td>Internet Order</td>
              <td>{{detail.transaction.internet_order ? detail.transaction.internet_order + '%' : '-'}}</td>
            </tr>
            <tr>
              <td>Telephone Order</td>
              <td>{{detail.transaction.telephone_order ? detail.transaction.telephone_order + '%' : '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Sales Distribution</td>
            </tr>
            <tr>
              <td>Sales Swiped</td>
              <td>{{detail.transaction.sales_swiped ? detail.transaction.sales_swiped + '%' : '-'}}</td>
            </tr>
            <tr>
              <td>Sales Keyed</td>
              <td>{{detail.transaction.sales_keyed ? detail.transaction.sales_keyed + '%' : '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Bank Account Information (For Deposits)</td>
            </tr>
            <tr>
              <td>Bank/Financial Institution Name</td>
              <td>{{detail.bank_detail.bank_name || '-'}}</td>
            </tr>
            <tr>
              <td>Routing #</td>
              <td>{{detail.bank_detail.routing || '-'}}</td>
            </tr>
            <tr>
              <td>Account #</td>
              <td>{{detail.bank_detail.account || '-'}}</td>
            </tr>
            <tr>
              <td>Bank Account Type</td>
              <td>{{detail.bank_detail.bank_account_type || '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Processing History</td>
            </tr>
            <tr>
              <td>Do you currently accept Visa/Mastercard/Discover?</td>
              <td>{{detail.transaction.accept_card ? 'Yes':'No' }}</td>
            </tr>
            <tr>
              <td>Have you ever had a merchant account terminated (TMF/MATCH)?</td>
              <td>{{detail.transaction.tmf ? 'Yes':'No' }}</td>
            </tr>
            <tr>
              <td>Are you on the TMF match list?</td>
              <td>{{detail.transaction.on_tmf=='yes' ? 'Yes':'No'}}</td>
            </tr>
            <tr>
              <td>Has any Principle filed for Bankruptcy</td>
              <td>{{detail.transaction.principle_bankruptcy ? 'Yes':'No'}}</td>
            </tr>
            <tr>
              <td>Bankruptcy Explanation</td>
              <td>{{detail.transaction.bankruptcy_description || '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td
                class="details-section"
                colspan="2"
              >Cardholder Data Storage Compliance & Service Provider</td>
            </tr>
            <tr>
              <td>Have you ever experienced an Account Data Compromise "ADC"?</td>
              <td>{{detail.transaction.account_Data_Compromise=='yes' ? 'Yes':'No'}}</td>
            </tr>
            <tr>
              <td>If yes, provide date of compromise</td>
              <td>{{detail.transaction.account_Data_Compromise_date || '-'}}</td>
            </tr>
            <tr>
              <td>a) Have you validated PCI DSS (Payment Card Industry Data Security Standard) compliance?</td>
              <td>{{detail.transaction.pci_dss=='yes' ? 'Yes':'No'}}</td>
            </tr>
            <tr>
              <td>Date of compliance, Report on Compliance "ROC" or Self Assessment Questionnaire "SAQ"?</td>
              <td>{{detail.transaction.roc_saq=='yes' ? 'Yes':'No'}}</td>
            </tr>
            <tr>
              <td>What is the name of your Qualified Security Assessor "QSA"</td>
              <td>{{detail.transaction.qsa=='yes' ? 'Yes':'No'}}</td>
            </tr>
            <tr>
              <td>Date of last scan</td>
              <td>{{detail.transaction.last_scan_date || '-'}}</td>
            </tr>
            <tr>
              <td>Approved Scanning Vendor's name:</td>
              <td>{{detail.transaction.vendor_name || '-'}}</td>
            </tr>
            <tr>
              <td>Do your transactions process through any other Service Provider (ie web hosting companies, gateways, corporate office)?</td>
              <td>{{detail.transaction.service_provider=='yes' ? 'Yes':'No'}}</td>
            </tr>
            <tr>
              <td>If yes, name the other Service Provider?</td>
              <td>{{detail.transaction.service_provider_name || '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Equipment</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Equipment Information</td>
            </tr>
            <tr>
              <td>How will you be accepting credit cards?</td>
              <td v-if="!detail.transaction.equipment">-</td>
              <td v-else-if="detail.transaction.equipment > 2">Online Shopping Cart</td>
              <td v-else-if="detail.transaction.equipment">{{detail.transaction.equipment_name}}</td>
            </tr>
            <tr v-if="detail.transaction.equipment > 2">
              <td>What shopping cart are you using?</td>
              <td>{{detail.transaction.equipment > 2 ? detail.transaction.equipment_name:'-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Documentation</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Supporting Documents</td>
            </tr>
            <tr>
              <td>Drivers License</td>
              <td>
                <a
                  v-if="detail.encoded_url.driver_license"
                  :href="detail.encoded_url.driver_license"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>Voided Check</td>
              <td>
                <a
                  v-if="detail.encoded_url.Voided_Check"
                  :href="detail.encoded_url.Voided_Check"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>Articles of Incorporation</td>
              <td>
                <a
                  v-if="detail.encoded_url.Articles_of_Incorporation"
                  :href="detail.encoded_url.Articles_of_Incorporation"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>(4) Months of Bank Statements</td>
              <td>
                <a
                  v-if="detail.encoded_url.Months_of_Bank_Statements"
                  :href="detail.encoded_url.Months_of_Bank_Statements"
                  class="view-document"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>(4) Months of Processing Statements</td>
              <td>
                <a
                  v-if="detail.encoded_url.Months_of_Processing_Statements"
                  :href="detail.encoded_url.Months_of_Processing_Statements"
                  class="view-document"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Signing</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">SignEasy</td>
            </tr>
            <tr>
              <td>New Company Application</td>
              <td>
                <a
                  v-if="detail.signed_file_url"
                  :href="detail.signed_file_url"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["param"],
  data: () => {
    return {
      detail: [],
      complete: false
    };
  },
  created() {
    this.$store
      .dispatch("get_app_detail", this.param)
      .then(res => {
        this.detail = res.data;
        this.complete = true;
      })
      .catch(err => {});
  }
};
</script>
<style scoped>
#details-app-page {
  margin-bottom: 100px;
}
.details-table .business-type {
  display: inline;
}
.details-section-row {
  background: #f3e5f5;
}
.details-section {
  font-weight: bold;
  font-size: 20px;
}
.details-table tr td:first-child {
  font-weight: bold;
}
.details-table tr td:first-child {
  width: 65%;
}
.details-table tr:hover:not(.details-section-row) {
  background: #fafafa;
}
@media (max-width: 767.98px) {
  .app-section {
    padding: 25px;
  }
}
</style>

